module.exports = __webpack_public_path__ + "static/media/mp-mobile-signup-drone.4d2a94d3.svg";